import { RowDataAdmin } from "../AdminPage/types";
import { RowDataMember } from "../MemberPage/types";
import { RowDataTransaction } from "../TransactionPage/types";
import { RowDataKPI, RowDataStaff } from "../StaffPage/types";
import { RowDataMain } from "../MainPage/types";
import { RowDataKPIObjective } from "../KpiPage/types";
import { RowDataBanner } from "../BannerPage/types";
import { RowDataVoucher } from "../VoucherPage/types";
import { RowDataNotification } from "../Notification/types";
import { RowDataOrder } from "../OrderPage/types";
import { RowDataMerchandise } from "../MerchandisePage/types";
import { RowDataDealer } from "../DealerPage/types";
import { RowDataPDFPriceList } from "../PDFPriceListPage/types";
import { RowDataSplashScreen } from "../SplashScreenPage/types";
import { RowDataPrebuild } from "../PrebuildPage/types";
import { RowDataTerms } from "../TermsPage/types";
import { RowDataCorporate } from "../CorporatePage/types";
import { RowDataDealerRebate } from "../DealerRebatePage/types";
import { RowDataBdayVoucher } from "../VoucherBirthdayPage/types";
import { RowDataPCComponent } from "../PCComponentIncompletePage/types";
import { RowDataPCComponentParameter } from "../PCComponentParameterPage/types";
import { RowDataStoreItem } from "../StoreItemIncompletePage/types";
import { RowDataAllItem } from "../AllItemPage/types";
import { RowDataGPU, RowDataGames } from "../GamesFPSPage/types";
import { RowDataBuildConfigPrebuild } from "../BuildConfigPrebuildPage/types";
import { RowDataBuildConfigCustom } from "../BuildConfigCustomPage/types";
import { RowDataBannerWeb } from "../BannerWebPage/types";
import { RowDataReview } from "../ReviewPage/types";
import { RowDataWebOrder } from "../WebOrderPage/types";
import { RowDataContactUs } from "../ContactUsPage/types";
import { RowDataBuildConfigEasy } from "../BuildConfigEasyPage/types";
import { RowDataContact} from "../ContactPage/types";
import { RowDataPdfGpu } from "../PdfGpuPage/types";


export enum RowDataTypes {
  ADMIN = "admin",
  MEMBER = "member",
  TRANSACTION = "transaction",
  STAFF = "staff",
  KPI = "kpi",
  MAIN = "main",
  KPIObjective = "kpiObjective",
  BANNER = "banner",
  VOUCHER = "voucher",
  NOTIFICATION = "notification",
  ORDER = "order",
  MERCHANDISE = "merchandise",
  DEALER = "dealer",
  PDFPRICELIST = "priceListPDF",
  SPLASHSCREEN = "splashScreen",
  PREBUILD = "prebuild",
  TERMS = "terms",
  CORPORATE = "corporate",
  DEALERREDATE = "dealerRebate",
  BDAYVOUCHER = "bdayVoucher",
  PCCOMPONENT = "pcComponent",
  PCCOMPONENTPARAMETER = "pcComponentParameter",
  STOREITEM = "storeItem",
  ALLITEM = "allItem",
  GPU = "gpu",
  GAMES = "games",
  BUILDCONFIGPREBUILD = "buildConfigPrebuild",
  BUILDCONFIGCUSTOM = "buildConfigCustom",
  BANNERWEB = "bannerWeb",
  REVIEW =  "review",
  WEBORDER = "webOrder",
  CONTACTUS = "contactUs",
  BUILDCONFIGEASY = "buildConfigEasy",
  CONTACT = "contact",
  PDFGPU = "pdfGpu",
}

export const admin = RowDataTypes.ADMIN,
  member = RowDataTypes.MEMBER,
  transaction = RowDataTypes.TRANSACTION,
  staff = RowDataTypes.STAFF,
  kpi = RowDataTypes.KPI,
  main = RowDataTypes.MAIN,
  kpiObjective = RowDataTypes.KPIObjective,
  banner = RowDataTypes.BANNER,
  voucher = RowDataTypes.VOUCHER,
  notification = RowDataTypes.NOTIFICATION,
  orders = RowDataTypes.ORDER,
  merchandise = RowDataTypes.MERCHANDISE,
  dealer = RowDataTypes.DEALER,
  priceListPDF = RowDataTypes.PDFPRICELIST,
  splashScreen = RowDataTypes.SPLASHSCREEN,
  prebuild = RowDataTypes.PREBUILD,
  terms = RowDataTypes.TERMS,
  corporate = RowDataTypes.CORPORATE,
  dealerRebate =RowDataTypes.DEALERREDATE,
  bdayVoucher = RowDataTypes.BDAYVOUCHER,
  pcComponent = RowDataTypes.PCCOMPONENT,
  pcComponentParameter = RowDataTypes.PCCOMPONENTPARAMETER,
  storeItem = RowDataTypes.STOREITEM,
  allItem = RowDataTypes.ALLITEM,
  gpu = RowDataTypes.GPU,
  games = RowDataTypes.GAMES,
  buildConfigPrebuild = RowDataTypes.BUILDCONFIGPREBUILD,
  buildConfigCustom = RowDataTypes.BUILDCONFIGCUSTOM,
  bannerWeb = RowDataTypes.BANNERWEB,
  review = RowDataTypes.REVIEW,
  webOrder = RowDataTypes.WEBORDER,
  contactUs = RowDataTypes.CONTACTUS,
  buildConfigEasy = RowDataTypes.BUILDCONFIGEASY,
  contact = RowDataTypes.CONTACT,
  pdfGpu = RowDataTypes.PDFGPU;

//Key-value pair mapping enum of row data types to their approriate row data types
export type RowDataTypesMap = {
  [admin]: RowDataAdmin;
  [member]: RowDataMember;
  [transaction]: RowDataTransaction;
  [staff]: RowDataStaff;
  [kpi]: RowDataKPI;
  [main]: RowDataMain;
  [kpiObjective]: RowDataKPIObjective;
  [banner]: RowDataBanner;
  [voucher]: RowDataVoucher;
  [notification]: RowDataNotification;
  [orders]: RowDataOrder;
  [merchandise]: RowDataMerchandise;
  [dealer]: RowDataDealer;
  [priceListPDF]: RowDataPDFPriceList;
  [splashScreen]: RowDataSplashScreen;
  [prebuild]: RowDataPrebuild;
  [terms]: RowDataTerms;
  [corporate]: RowDataCorporate;
  [dealerRebate]: RowDataDealerRebate;
  [bdayVoucher]: RowDataBdayVoucher;
  [pcComponent]: RowDataPCComponent;
  [pcComponentParameter]: RowDataPCComponentParameter
  [storeItem]: RowDataStoreItem;
  [allItem]: RowDataAllItem;
  [gpu]: RowDataGPU;
  [games]: RowDataGames;
  [buildConfigPrebuild]: RowDataBuildConfigPrebuild;
  [buildConfigCustom]: RowDataBuildConfigCustom;
  [bannerWeb]: RowDataBannerWeb;
  [review]: RowDataReview;
  [webOrder]: RowDataWebOrder;
  [contactUs]: RowDataContactUs;
  [buildConfigEasy]: RowDataBuildConfigEasy;
  [contact]: RowDataContact;
  [pdfGpu]: RowDataPdfGpu
};
